export const CHECKOUT_LINKS = {
  esencial:
    'https://www.stockdigital.shop/checkouts/cn/hWNBpA8AHP6z7TeXqqrGRg7W/es-ar?_r=AQABstqqc-KsQY9KGfsQsUslY-T_zP4ud2ZfHMvsGZPCDIU&cart_link_id=fZ64mSUK&preview_theme_id=140123340859',
  completo:
    'https://www.stockdigital.shop/checkouts/cn/hWNBpBZqj1mnVPp7fCRikHUA/es-ar?_r=AQAB-xKRxpq8d_tPdcePJAN0XHq0ouV3Bmm9aD1JVeEuLTI&cart_link_id=BMdCbNZV&preview_theme_id=140123340859',
} as const
